export default __webpack_public_path__ + "static/media/materialdesignicons-webfont.52adde0d.eot";